import { CommonAppConfigurationMapper, ICommonAppConfigurations, ICommonAppConfigurationsDTO } from "@/@common/models/CommonAppConfigurations";
import { gateBooleanToBoolean } from "../../../sg-core";
import { EProcessingMarkingPublicity } from "./IObservation";


type TGateBoolean = "Y" | "N";

export interface IAppConfigurations extends ICommonAppConfigurations {
    havainnot: {
        muokkaus: { sallittu: boolean };
        oletukset: { julkisuus: boolean };
        arkistointi_suodatin: boolean;
        nayta_yksiloiva_tunniste?: boolean;
    };

    kasittelymerkinnat: {
        julkisuus: { valittavissa: boolean };
        oletukset: { julkisuus: EProcessingMarkingPublicity };
    };

    esitys: {
        kentat: { tyhjat: { piilotus: boolean } }
    }
}



export interface IAppConfigurationsDTO extends ICommonAppConfigurationsDTO {
    havainnot: {
        muokkaus: { sallittu: TGateBoolean };
        oletukset: { julkisuus: TGateBoolean };
        arkistointi_suodatin: TGateBoolean;
        nayta_yksiloiva_tunniste?: TGateBoolean
    };

    kasittelymerkinnat: {
        julkisuus: { valittavissa: TGateBoolean };
        oletukset: { julkisuus: "kaikki" | "ei_mikaan" | "viimeisin" };
    };
    esitys: {
        kentat: { tyhjat: { piilotus: TGateBoolean } }
    }
};


/**
 * Mapper primarly uses app spesific parameter and fallbacks to common parameters used in all safety applications.
 */
export const AppConfigurationMapper = {
    apiToDomain: (api: IAppConfigurationsDTO): IAppConfigurations => {

        return {
            ...CommonAppConfigurationMapper.apiToDomain(api),

            havainnot: {
                muokkaus: { sallittu: gateBooleanToBoolean(api.havainnot.muokkaus.sallittu) },
                oletukset: { julkisuus: gateBooleanToBoolean(api.havainnot.oletukset.julkisuus) },
                arkistointi_suodatin: gateBooleanToBoolean(api.havainnot.arkistointi_suodatin),
                nayta_yksiloiva_tunniste: api.havainnot.nayta_yksiloiva_tunniste ? gateBooleanToBoolean(api.havainnot.nayta_yksiloiva_tunniste) : true,
            },

            kasittelymerkinnat: {
                julkisuus: { valittavissa: gateBooleanToBoolean(api.kasittelymerkinnat.julkisuus.valittavissa) },
                oletukset: { julkisuus: api.kasittelymerkinnat.oletukset.julkisuus as EProcessingMarkingPublicity },
            },

            esitys: {
                kentat: { tyhjat: { piilotus: gateBooleanToBoolean(api.esitys.kentat.tyhjat.piilotus) } }
            }
        }
    },
};


